import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface PlusIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number | string;
}

const PlusIcon: React.FC<PlusIconProps> = ({ strokeWidth = 4, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 50 50" className="sx-icon-plus">
    <path
      d="M25 7 V43 M7 25 H43"
      fill="none"
      stroke={props.color || 'currentColor'}
      strokeWidth={strokeWidth}
      strokeLinecap="butt"
    />
  </SvgIcon>
);

export default PlusIcon;
